module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-4.86c23094.png";